import { render, staticRenderFns } from "./BIWorksheet.vue?vue&type=template&id=f1b2b282&scoped=true&"
import script from "./BIWorksheet.vue?vue&type=script&lang=ts&"
export * from "./BIWorksheet.vue?vue&type=script&lang=ts&"
import style0 from "./BIWorksheet.vue?vue&type=style&index=0&id=f1b2b282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2b282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout})
